import { useState } from "react";
import httpService from "../services/httpService";
import posthog from 'posthog-js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { FaArrowRightFromBracket, FaSpinner } from "react-icons/fa6";
import AnimatedImage from "../components/AnimatedImage";

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [tokenError, setTokenError] = useState("");
    const [formData, setFormData] = useState({ password: "", password_confirmation: "" });
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? '';
    const email = searchParams.get('email') ?? '';

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setTokenError("");
        setErrors({});
        try {
            await httpService.post("password/reset", { token, email, ...formData });
            posthog.capture('password_reset_completed');
            navigate('/login');
        } catch (err) {
            const data = err.response?.data;
            if (data?.errors?.token) {
                setTokenError(data.errors.token[0]);
            } else if (data?.errors) {
                setErrors(data.errors);
            } else {
                setTokenError("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <Card style={{ overflow: 'hidden' }}>
                        <Row className="g-0">
                            <Col>
                                <div className='p-3'>
                                    <div className={'position-absolute'}>
                                        <Link to="/login"><FaArrowRightFromBracket /></Link>
                                    </div>
                                    <div className={'text-center'}>
                                        <AnimatedImage
                                            src="/img/podsy-logo-w-200.png"
                                            fluid
                                            alt="Podsy Logo"
                                            loopMs={3000}
                                            aberration={true}
                                            className=""
                                        />
                                    </div>

                                    <h5 className="text-center mb-3">Choose a new password</h5>

                                    {tokenError && (
                                        <Alert variant="danger" className="small">
                                            {tokenError}{' '}
                                            <Link to="/forgot-password">Request a new link.</Link>
                                        </Alert>
                                    )}

                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3" controlId="Password">
                                            <Form.Label>New password</Form.Label>
                                            <Form.Control
                                                name="password"
                                                type="password"
                                                disabled={loading}
                                                placeholder="New password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                isInvalid={!!errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.password?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-4" controlId="PasswordConfirmation">
                                            <Form.Label>Confirm new password</Form.Label>
                                            <Form.Control
                                                name="password_confirmation"
                                                type="password"
                                                disabled={loading}
                                                placeholder="Confirm new password"
                                                value={formData.password_confirmation}
                                                onChange={handleChange}
                                                isInvalid={!!errors.password_confirmation}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.password_confirmation?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Button disabled={loading || !!tokenError} className="w-100 mb-3" variant="light" type="submit">
                                            {loading ? <FaSpinner className={"loading_spinner"} /> : 'Reset password'}
                                        </Button>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword;
